import { IDispatchId, IRequestError } from '../../utils/helpers/redux.helper';
import { RenewalInfo } from './models/renewal-info.model';

// action enums
export enum ActionsEnum {
  FETCH_RENEWAL_INFO = 'FETCH_RENEWAL_INFO',
  FETCH_RENEWAL_INFO_SUCCESS = 'FETCH_RENEWAL_INFO_SUCCESS',
  FETCH_RENEWAL_INFO_ERROR = 'FETCH_RENEWAL_INFO_ERROR',
  UPDATE_RENEWAL_INFO = 'UPDATE_RENEWAL_INFO',
}

// action payloads
export interface IRenewalInfo {
  renewalInfo: RenewalInfo;
}

export interface IFetchRenewalInfo extends IDispatchId {
  dispatchId: string;
}

// action definitions
export interface FetchRenewalInfo {
  type: ActionsEnum.FETCH_RENEWAL_INFO;
  payload: IFetchRenewalInfo;
}

export interface FetchRenewalInfoSuccess {
  type: ActionsEnum.FETCH_RENEWAL_INFO_SUCCESS;
  payload: IDispatchId;
}

export interface FetchRenewalInfoError {
  type: ActionsEnum.FETCH_RENEWAL_INFO_ERROR;
  payload: IRequestError;
}

export interface UpdateRenewalInfo {
  type: ActionsEnum.UPDATE_RENEWAL_INFO;
  payload: IRenewalInfo;
}

// action creators
export const fetchRenewalInfo = (dispatchId: string): FetchRenewalInfo => ({
  type: ActionsEnum.FETCH_RENEWAL_INFO,
  payload: {
    dispatchId,
  },
});

export const fetchRenewalInfoSuccess = (
  dispatchId: string
): FetchRenewalInfoSuccess => ({
  type: ActionsEnum.FETCH_RENEWAL_INFO_SUCCESS,
  payload: {
    dispatchId,
  },
});

export const fetchRenewalInfoError = (
  dispatchId: string,
  error: Error
): FetchRenewalInfoError => ({
  type: ActionsEnum.FETCH_RENEWAL_INFO_ERROR,
  payload: {
    dispatchId,
    error,
  },
});

export const updateRenewalInfo = (
  renewalInfo: RenewalInfo
): UpdateRenewalInfo => ({
  type: ActionsEnum.UPDATE_RENEWAL_INFO,
  payload: {
    renewalInfo,
  },
});
